<script setup lang="ts">
import { ref } from "vue";

import { useRoute, useRouter } from "vue-router";

import SetupBackupStep from "./setup/SetupBackupStep.vue";
import SetupIdentityStep from "./setup/SetupIdentityStep.vue";
import SetupProtectStep from "./setup/SetupProtectStep.vue";

const AVATARS = Object.keys(
    import.meta.glob("/src/shared/ui/icons/avatars/*.svg")
).sort();

const router = useRouter();
const route = useRoute();

const step = ref<"identity" | "protect" | "backup">("identity");
const name = ref("");
const avatar = ref(AVATARS[0]);

function redirectAfterSetup() {
    const redirect = route.query.redirect;
    router.replace(typeof redirect === "string" ? redirect : "/app");
}
</script>

<template>
    <div class="mc-setup">
        <div class="mc-setup__card">
            <SetupIdentityStep
                v-if="step === 'identity'"
                v-model:name="name"
                v-model:avatar="avatar"
                :avatars="AVATARS"
                @next="step = 'protect'"
                @link="router.push('/app/link')"
            />

            <SetupProtectStep
                v-else-if="step === 'protect'"
                :name="name"
                :avatar="avatar"
                @backup="step = 'backup'"
                @done="redirectAfterSetup"
            />

            <SetupBackupStep
                v-else
                @done="redirectAfterSetup"
                @skip="router.replace('/')"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.mc-setup {
    height: 100%;
    overflow: auto;
    display: flex;
    justify-content: center;
    padding: 40px;
    // Подложка темнее корпуса окна — карточка шага читается как отдельный слой.
    background: var(--mc-bg-app);

    @media (max-width: bp.$mobile) {
        padding: 20px;
    }

    // margin:auto вместо align-items:center — при высоком контенте карточка
    // не обрезается сверху, а прижимается к отступу.
    &__card {
        margin: auto;
        width: 100%;
        max-width: 640px;
        padding: 40px;
        background: var(--mc-bg-window);
        border: 1px solid var(--mc-line-hard);
        box-shadow: 0 30px 90px rgba(0, 0, 0, 0.6);

        @media (max-width: bp.$mobile) {
            padding: 24px 20px;
        }
    }
}
</style>
